import styled from "styled-components";

import { aiAgentBoxBorderStroke } from "app/pages/sales-intelligence/modules/ai-agent/components";

export const StyledAiErrorStateContainer = styled.div`
    border-radius: 8px;
    ${aiAgentBoxBorderStroke};
    padding: 44px 0;
`;
